import React from 'react';
import Navbar from '../Navigation';
import {About, Projects, Blog, Contact } from '../Pages';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import './main.css';

const navLinks = [
  {
    title: "About",
    pathId: "#About"
  },
  {
    title: "Projects",
    pathId: "#Projects"
  },
  {
    title: "Blog",
    pathId: "/blog"
  },
  {
    title: "Contact",
    pathId: "#Contact"
  }
]

function App() {
  console.log("App is rendered");
  console.log("----------------");

  const [blogClicked, setBlogClicked] = React.useState(false);
  
  return (
    <Router>
    <div className="App">
      <Navbar navLinks={navLinks} onBlogClick={setBlogClicked}/>
      {blogClicked ? 
      (<Switch>
        <Route path='/blog' component={Blog} />
      </Switch>)
       : 
       (<>
          <About />
          <Projects />
          <Contact />
        </>
      )}
      <footer>Made with ❤️ by Lily Yang, and <span>Icons made by <a href="https://icon54.com/" title="Pixel perfect">Pixel perfect</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></span></footer>
    </div>
    </Router>
  );
}

export default App;
